import FlashLib from 'flashlib_onlyplay';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import EntryPoint from 'Engine/EntryPoint';
import MoneyFormat from 'Engine/base/moneyFormat/MoneyFormat';
import { jackpotValues, jackpotStrokes, mainGoldFont } from '../../fontStyles';

export default class BaseControllerJackpotsPanel extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);
    this.ePanelTypes = {
      EPT_GRAND: 'grand',
      EPT_MEGA: 'major',
      EPT_MAJOR: 'mini',
    };
    this.timeouts = [];
    this.init();
    this.setTextStyles();
    this.updatePanels();
    this.addListeners()
  }

  init() {
    this.title = this.getChildByName('jackpot_panels_title');
    this.panels = [];
    this.grandPanel = this.getChildByName('grand');
    this.grandPanel.type = this.ePanelTypes.EPT_GRAND;
    this.panels.push(this.grandPanel);
    this.grandPanelAmount = this.grandPanel.getChildByName('textAmount');
    this.grandPanelTitle = this.grandPanel.getChildByName('jackpot_panels_0');
    this.megaPanel = this.getChildByName('mega');
    this.megaPanel.type = this.ePanelTypes.EPT_MEGA;
    this.panels.push(this.megaPanel);
    this.megaPanelAmount = this.megaPanel.getChildByName('textAmount');
    this.megaPanelTitle = this.megaPanel.getChildByName('jackpot_panels_1');
    this.majorPanel = this.getChildByName('major');
    this.majorPanel.type = this.ePanelTypes.EPT_MAJOR;
    this.panels.push(this.majorPanel);
    this.majorPanelAmount = this.majorPanel.getChildByName('textAmount');
    this.majorPanelTitle = this.majorPanel.getChildByName('jackpot_panels_2');
  }

  addListeners() {
    GlobalDispatcher.add('model:betChanged', this.updatePanels, this);
    window.OPWrapperService.eventManager.add(
      window.OPWrapperService.eventManager.types.EET_SCALE_MANAGER_RESIZE,
      this.onResize,
      this
    );
  }

  onResize(data) {
    this.setTextStyles();
    this.updatePanels();
  }

  setTextStyles() {
    if(this.title) {
      this.title.style = { ...this.title.style, ...mainGoldFont };
    }
    this.grandPanelTitle.style = { ...this.grandPanelTitle.style, ...mainGoldFont };
    this.grandPanelAmount.style = { ...this.grandPanelAmount.style, ...jackpotValues, ...jackpotStrokes[0] };
    this.megaPanelTitle.style = { ...this.megaPanelTitle.style, ...mainGoldFont };
    this.megaPanelAmount.style = { ...this.megaPanelAmount.style, ...jackpotValues, ...jackpotStrokes[1] };
    this.majorPanelTitle.style = { ...this.majorPanelTitle.style, ...mainGoldFont };
    this.majorPanelAmount.style = { ...this.majorPanelAmount.style, ...jackpotValues, ...jackpotStrokes[2] };
  }

  updatePanels() {
    const decimals = EntryPoint.GameModel.currencyInfo.decimals;
    this.grandPanelAmount.text = MoneyFormat.formatCurrency(EntryPoint.GameModel.jackpotList[2], decimals);
    this.megaPanelAmount.text = MoneyFormat.formatCurrency(EntryPoint.GameModel.jackpotList[1], decimals);
    this.majorPanelAmount.text = MoneyFormat.formatCurrency(EntryPoint.GameModel.jackpotList[0], decimals);
  }
}

